import React from "react";
import { motion } from "motion/react";

export const TestimonialsColumn = (props) => {
  const { className, testimonials, duration = 10 } = props;
  
  return (
    <div className={className}>
      <motion.div
        animate={{
          translateY: "-50%",
        }}
        transition={{
          duration: duration,
          repeat: Infinity,
          ease: "linear",
          repeatType: "loop",
        }}
        className="flex flex-col gap-6 pb-6 bg-background"
      >
        {[...new Array(2)].fill(0).map((_, index) => (
          <React.Fragment key={index}>
            {testimonials.map(({ text, image, name, role }, i) => (
              <div 
                className="p-8 rounded-2xl border border-gray-100 shadow-lg shadow-blue-900/5 max-w-xs w-full bg-white" 
                key={i}
              >
                <div className="text-gray-700 leading-relaxed mb-6">
                  "{text}"
                </div>
                <div className="flex items-center gap-3">
                  <img
                    width={48}
                    height={48}
                    src={image}
                    alt={name}
                    className="h-12 w-12 rounded-full object-cover"
                  />
                  <div className="flex flex-col">
                    <div className="font-semibold tracking-tight leading-5 text-blue-900">
                      {name}
                    </div>
                    <div className="leading-5 opacity-70 tracking-tight text-gray-600 text-sm">
                      {role}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </React.Fragment>
        ))}
      </motion.div>
    </div>
  );
};